import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'cpui-antenna',
  templateUrl: './antenna.component.html',
  styleUrls: ['./antenna.component.scss']
})
export class AntennaComponent implements OnInit {
  @Input() isBlurred: boolean;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/antenna/antenna.component.ts